<template>
    <v-dialog
      :fullscreen="$vuetify.breakpoint.smAndDown"
      v-model="modal_credit"
      persistent
      max-width="700px"
    >
      <v-card>
        <v-card-title class="pb-0">
          <v-container class="pb-0">
            <p class="primary--text">Pre-solicitud de Crédito</p>
          </v-container>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-row>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field v-model="name" label="Nombre completo *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field v-model="email" label="Correo electronico *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field v-model="address" label="Direccion del negocio * "></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field v-model="colony" label="Colonia * "></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field v-model="city" label="Cuidad o localidad *"></v-text-field>
              </v-col>                
              <v-col class="py-0" cols="12" sm="6">
                <v-text-field v-model="cp" label="Código postal *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12">
                <v-text-field v-model="phone" v-mask="'(###)-###-####'" label="Telefono con lada *"></v-text-field>
              </v-col>
              <v-col class="py-0" cols="12">
                <v-autocomplete
                  v-model="giro"
                  :items="['Abarrotes', 'Carniceria', 'Constructora', 'Consultorios médicos', 'Dulcerías', 'Electronica y Computo', 'Farmacias', 'Fotografia (estudio)', 'Fruterías','Hoteles y Moteles','Imprentas y editoriales','Joyeria y relojeria','Laboratorios clínicos','Librerias','Madererías','Marisquerías','Mueblería','Panaderias','Purificadora de agua','Refaccionaria','Restaurante','Rosticeria','Talleres','Telefonia','Tortillerias','Videoclub','Vinos y licores','Otro comercio o negocio']"
                  label="Giro de su negocio * "
                ></v-autocomplete>
              </v-col>
            </v-row>
          </v-container>
          <small>*indica el campo requerido</small>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="default" text @click="$store.dispatch('home/setModalCredit',false)" :loading="isLoading">Cancelar</v-btn>
          <v-btn color="primary_dark" text @click="send()" :loading="isLoading">Enviar solicitud</v-btn>
        </v-card-actions>
      </v-card>
      <v-snackbar v-model="snackbar.model" :color="snackbar.color" top>
        <b>{{ snackbar.text }}</b>
        <v-btn text @click="snackbar.model = false">Aceptar</v-btn>
      </v-snackbar>
    </v-dialog>
</template>
<style scoped>
.bg-red {
  background-color: #8a172b !important;
}
.boldFont {
  font-weight: bolder !important;
}
.black-font {
  color: black !important;
}
</style>
<script>
import { mapState } from "vuex";
import axios from "axios";
import { mask } from "vue-the-mask";
export default {
  directives: {
    mask
  },
  props: [],
  data() {
    return {
      isLoading: false,
      name:"",
      email:"",
      address:"",
      colony:"",
      city:"",
      cp:"",
      phone:"",
      giro:"",
      snackbar: {
        model: false,
        color: "green",
        text: ""
      }
    };
  },
  computed: {
    ...mapState({
      modal_credit: state => state.home.modal_credit,
      type: state => state.home.type,
    }),
  },
  methods: {
    send() {
      if (
        this.name == "" || 
        this.email == "" || 
        this.address == "" || 
        this.colony == "" || 
        this.city == "" || 
        this.cp == "" || 
        this.phone == "" || 
        this.giro == ""
      ) {
        this.snackbar.text = "Complete los campos";
        this.snackbar.model = true;
        this.snackbar.color = "red";
        return;
      }
      this.isLoading = true;
      let self = this;
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("email", this.email);
      formData.append("address", this.address);
      formData.append("colony", this.colony);
      formData.append("city", this.city);
      formData.append("cp", this.cp);
      formData.append("phone", this.phone);
      formData.append("type", this.type);
      formData.append("giro", this.giro);
      axios({
        method: "post",
        url: "https://www.software.tidingo.com/api/send-capitalica-credit",
        data: formData,
        config: {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Control-Allow-Origin": "*"
          }
        }
      })
      .then(function(response) {
        self.isLoading = false;
        if (response.data.status == 200) {
          self.snackbar.text = "Correo enviado exitosamente";
          self.snackbar.model = true;
          self.snackbar.color = "green";
          self.clean();
        } else {
          self.snackbar.text = "Correo no enviado, intente nuevamente";
          self.snackbar.model = true;
          self.snackbar.color = "red";
        }
      })
      .catch(function() {
        self.isLoading = false;
      });
    },
    clean() {
      this.name = "";
      this.tel = "";
      this.email = "";
      this.coment = "";
      this.sucursal = "";
      this.$store.dispatch('home/setModalCredit',false)
    }
  }
};
</script>